export default "__VITE_ASSET__DLwdz7XU__"